export const EXPORT_OPTIONS = [
	{
		label: 'Export as image',
		value: 'png',
	},
	{
		label: 'Export as data',
		value: 'xlsx',
	},
];

export const CATEGORY_OPTIONS = [
	{
		label: 'Vendors',
		value: 'vendor',
	},
	{
		label: 'Selected category',
		value: 'category',
	},
	{
		label: 'L4 category',
		value: 'categoryL4',
	},
];

export const INDIRECT = 'Indirect';
export const DIRECT = 'Direct';
